import React from 'react';

import ColumnSection from '@/components/ColumnSection';
import Divider from '@/components/Divider';

import s from './Notes.module.scss';

export default function Notes({ notes }: any) {
  return (
    <div>
      <Divider spacing={30} />
      <ColumnSection title="Request Notes">
        <span className={s.notes}>{notes}</span>
      </ColumnSection>
    </div>
  );
}
